export const RoleLabel = "Role";
export const ConfigurationLabel = "Configuration";
export const AddRoleLabel = "Add Role";
export const RoleKey = "role";
export const IdKey = "id";
export const SrNoLabel = "Sr No";
export const NameLabel = "Name";
export const NameKey = "name";
export const RoleNameLabel = "Role Name";
export const RoleNameKey = "role_name";
export const newRoleLabel = "New Role";
export const viewRoleLabel = "View Role";
export const editRoleLabel = "Edit Role";
export const editLabel = "Edit";
export const DeleteLabel = "Delete";
export const activeLabel = "Active";
export const InactiveLabel = "Inactive";
export const activateLabel = "Activate";
export const InactivateLabel = "Inactivate";
export const updateLabel = "Update";
export const submitLabel = "Submit";
export const cancelLabel = "Cancel";
export const PermissionsLabel = "Permissions";
export const PermissionsKey = "permissions";
export const NewLabel = "New";
export const StatusLabel = "Status";
export const StatusKey = "Status";
export const AuthUserPermissionLabel = "authUserPermission";
export const ActionLabel = "Action";
export const ActionKey = "action";
export const YesLabel = "Yes";
export const NoLabel = "No";
export const StatusUpdateLabel = "Status Update";
export const StatusUpdateMessageLabel = "Do you want to update the status?";
export const POPublishLabel = "Do you want to publish this Purchase Order?"
export const ROReturnPublishLabel = "Do you want to Return this RO?"
export const POReturnPublishLabel = "Do you want to Return this PO?"
